// Pure formatters — no DOM access. Safe to unit-test.

export function fmtN(v) {
  return v == null ? '—' : '$' + Math.round(v).toLocaleString('en-US');
}

export function fmtVND(v) {
  return v == null ? '—' : Math.round(v).toLocaleString('vi-VN');
}

// Bug fix (#6 caught): `v = +v` coerces null → 0, defeating the `v == null` check.
// Always test for null BEFORE numeric coercion.

export function fmtP(v, d = 1) {
  if (v == null) return '—';
  const n = +v;
  return isNaN(n) ? '—' : (n * 100).toFixed(d) + '%';
}

export function fmtX(v, d = 1) {
  if (v == null) return '—';
  const n = +v;
  return isNaN(n) ? '—' : n.toFixed(d) + 'x';
}

export function fmtD(v) {
  if (v == null) return '—';
  const n = +v;
  return isNaN(n) ? '—' : n.toFixed(1) + ' d';
}

export function fmtU(v, u) {
  if (u === '%') return fmtP(v);
  if (u === 'x') return fmtX(v);
  if (u === 'days') return fmtD(v);
  if (u === 'kws') return v == null ? '—' : Math.round(+v) + ' kws';
  return fmtN(v);
}

export function fmtDisp(v, fmt) {
  if (v == null) return '—';
  v = +v;
  if (isNaN(v)) return '—';
  if (fmt === 'pct') return fmtP(v);
  if (fmt === 'vnd') return fmtN(v);
  return v % 1 === 0 ? Math.round(v).toString() : v.toFixed(1);
}

export function fmtInput(v, fmt) {
  v = +v;
  if (isNaN(v)) v = 0;
  if (fmt === 'pct') return (v * 100).toFixed(2);
  if (fmt === 'vnd') return Math.round(v).toString();
  return v % 1 === 0 ? Math.round(v).toString() : v.toFixed(2);
}

export function parseInput(s, fmt) {
  const n = parseFloat(s);
  if (isNaN(n)) return null;
  if (fmt === 'pct') return n / 100;
  return n;
}

export function inputSuffix(fmt, u) {
  if (fmt === 'pct') return '%';
  if (u === 'x') return 'x';
  if (u === 'days') return 'd';
  if (u === 'kws') return 'kws';
  return 'USD';
}
